import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {msg} from '@lit/localize';
import {connect} from 'pwa-helpers';
import store from '../../../store';
import {cssProperties} from '../../../css/cssProperties';

@customElement('visual-lightprofile-summary-footer')
export class VisualLightprofileSummaryFooter extends connect(store)(LitElement) {

	static styles = [
		css`
		.footerSection {
			background: #191919;
			padding-top: 20px;
			padding-bottom: 100px;
			position: relative;
		}

		.vl {
			border-left: 1px solid white;
			height: 100px;
		  	width: 1px;
			margin-bottom: 30px;
			left: 50%;
			position: relative;
		}

		  .footerText {
			color: var(--color-white);
			font: var(--font-info-light);
			line-height: 23px;
			margin: auto;
			max-width: 40%;
			text-align: center;
		  }

		.footerBig {
			color: var(--color-white);
			font: var(--font-modal-title);
			line-height: 34px;
			margin: auto;
			max-width: 40%;
			text-align: center;
		}

		.contactBtnGroup {
			margin: auto;
			margin-top: 100px;
			text-align: center;
		}

		.contactBtnGroup a {
			color: var(--color-white);
			background-color: transparent;
			border: 1px solid #fff;
			box-shadow: none;
			font-family: var(--font-family-light);
			margin: 0px 20px;
			padding: 15px 25px;
			text-decoration: none;

		}
		.price {
			color: var(--color-grey4);
			font-family: var(--font-family-light);
			position: absolute;
			top: -30px;
			right: var(--padding);
		}
		@media (max-width: 768px) {
			h1 {
				max-width: 80%;
			}
			.contactBtnGroup a {
				padding: 10px 15px;
			}

			div.footerText {
				max-width: 80%;
			}

			div.footerBig {
				max-width: 80%;
			}
		}
		`
	];

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}
	stateChanged(state) {
		this.state = state;
		this.translations = state.productData.translations;
		this.decisions = state.decisions.data;
		this.profile = state.lightProfile.data.profile;
		this.lightProfile = state.lightProfile.data;
		this.price = state.price.data;
		this.featureModelIsSatisfied = this.price?.totalPriceInEuro !== 0;
	}

	render() {
		const s = this.state;
		return html`
		<section class="footerSection">
			<div class="price">${this.featureModelIsSatisfied ? this.price.totalPriceInEuro : '--'}</div>
			<div class="vl"></div>
			<div class="footerText">
				<p>${msg('How must light work to create safety, orientation and beauty? How can we prevent our ecological limits from being further strained? Is there such a thing as perfect light? Nature provides the answers.')}</p>
				<p>${msg('This insight gave rise to the idea of adapting artificial light to natural rhythms: a little different every day, in every season and in every place in the world - but always unique.')}</p>
				<p>
					${msg('We look forward to the future of light.')}<br>
				</p>
			</div>
			<div class="footerBig">
				<strong>${msg('Feel free to contact us for a personal exchange and further information')}</strong>

			</div>
			<div class="contactBtnGroup">
				<a href="mailto:info@selux.de">info@selux.de</a>
				<a href="tel:+49 30 72 001 0">T +49 30 72 001 0</a>
		  	</div>
		</section>


		`;
	}
}
